
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/inventory/vickers",
      function () {
        return require("private-next-pages/en/inventory/vickers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/inventory/vickers"])
      });
    }
  